import BaseViz from './BaseViz'
import LineAndBarChartChart from '../charts/LineAndBarChartChart'
import LineAndBarDataController from '../viz_behaviors/LineAndBarDataController'
export default class LineAndBarChartViz extends BaseViz {
  static chartClass = LineAndBarChartChart
  static dataControllerClass = LineAndBarDataController
  static defaultConfig = {
    ItemsHelper: {
      colorScale: {
        nonEditable: [true,false],
        value: ['categorical2', 'single'],
        options:[['categorical2'],['categorical','single']],
        multiValueIds: ['Lines', 'Bars'],
      },
    },
    AxisHelper:{
      y: {
        trimThreshold: {
          nonEditable: true
        }
      },
      x: {
        trimThreshold: {
          nonEditable: true
        },
        valueFormat: {
          nonEditable: true
        },
        unit:{
          nonEditable: true
        },
        scale: {
          nonEditable: true,
          exposed: false
        }
      }
    }
  }
}
